module.exports = __webpack_public_path__ + "files/eae6abf99251b558e30dfab863e41d9b.png";